export default __webpack_public_path__ + "static/media/CloseCircle.f2522303.svg";